import React from "react";
import { Link } from "react-router-dom";
import PageTitle from "./include/PageTitle";
import { useI18n } from "../i18n/I18nContext";
import { getServiceDetailsCopy, getSidebarLinks } from "../content/localeCopy";
import LocalizedLeadParagraph from "../Components/LocalizedLeadParagraph";
import { useTranslatedCopy } from "../i18n/useTranslatedCopy";
import ServiceInquiryForm from "../Components/ServiceInquiryForm";
import Seo, { ARABIC_SEO_KEYWORDS, ENGLISH_SEO_KEYWORDS, buildServiceStructuredData, mergeSeoKeywords } from "../Components/Seo";

const developmentPageImages = [
  "/img/service/property-development-1.png",
  "/img/service/property-development-2.png",
  "/img/service/property-development-3.png",
];

const developmentSidebarImage = "/img/service/property-development-4.png";

const imageCardStyle = {
  background: "#ffffff",
  border: "1px solid rgba(187, 165, 92, 0.14)",
  borderRadius: "22px",
  overflow: "hidden",
  boxShadow: "0 16px 38px rgba(15, 23, 42, 0.08)",
  height: "100%",
};

const PropertyDevelopmentServiceDetails = () => {
  const { locale } = useI18n();
  const copy = useTranslatedCopy(getServiceDetailsCopy("development"), locale);
  const sidebar = useTranslatedCopy(getSidebarLinks(), locale);
  const matrixHeaderPhase = useTranslatedCopy("Phase", locale);
  const matrixHeaderDetails = useTranslatedCopy("Our Role as a Real Estate Developer", locale);
  const galleryCaptionOne = useTranslatedCopy("Planning, design, and licensing coordination", locale);
  const galleryCaptionTwo = useTranslatedCopy("Execution oversight and project value delivery", locale);
  const developmentGalleryTitle = useTranslatedCopy("How we guide projects from concept to delivery", locale);
  const developmentGalleryText = useTranslatedCopy(
    "Our development process combines planning, design coordination, execution supervision and commercial strategy to move projects forward with stronger quality control and long-term asset value.",
    locale
  );
  const lifecycleHeading = useTranslatedCopy("Project Lifecycle Under Our Supervision", locale);

  return (
    <div>
      <Seo
        title="Property Development in Saudi Arabia and Al Khobar | QTECH"
        titleAr="ØªØ·ÙˆÙŠØ± Ø¹Ù‚Ø§Ø±ÙŠ ÙÙŠ Ø§Ù„Ø®Ø¨Ø± | Ø´Ø±ÙƒØ© ØªÙ‚Ù†ÙŠØ§Øª Ø§Ù„Ø¬ÙˆØ¯Ø©"
        description="QTECH provides property development services in Saudi Arabia and Al Khobar, from feasibility review and concept development to consultant coordination, execution oversight, approvals, and handover."
        descriptionAr="ØªÙ‚Ø¯Ù… Ø´Ø±ÙƒØ© ØªÙ‚Ù†ÙŠØ§Øª Ø§Ù„Ø¬ÙˆØ¯Ø© Ø®Ø¯Ù…Ø§Øª ØªØ·ÙˆÙŠØ± Ø¹Ù‚Ø§Ø±ÙŠ ÙÙŠ Ø§Ù„Ø®Ø¨Ø± ÙˆØ§Ù„Ø³Ø¹ÙˆØ¯ÙŠØ© ØªØ´Ù…Ù„ ØªØ·ÙˆÙŠØ± Ø§Ù„Ù…Ø´Ø§Ø±ÙŠØ¹ Ø§Ù„Ø¹Ù‚Ø§Ø±ÙŠØ©ØŒ Ø¥Ø¯Ø§Ø±Ø© Ù…Ø´Ø§Ø±ÙŠØ¹ Ø¹Ù‚Ø§Ø±ÙŠØ©ØŒ Ø§Ù„ØªÙ†Ø³ÙŠÙ‚ Ù…Ø¹ Ø§Ù„Ù…Ù‚Ø§ÙˆÙ„ÙŠÙ†ØŒ ÙˆÙ…ØªØ§Ø¨Ø¹Ø© Ø§Ù„ØªÙ†ÙÙŠØ°."
        keywords={mergeSeoKeywords(
          ENGLISH_SEO_KEYWORDS.development,
          "real estate investment development Saudi Arabia, property investment development, investment project development Al Khobar, real estate development for investors"
        )}
        keywordsAr={mergeSeoKeywords(
          ARABIC_SEO_KEYWORDS.development,
          "استثمار عقاري, تطوير عقاري استثماري, تطوير مشاريع استثمارية, فرص تطوير عقاري في السعودية, تطوير عقاري للمستثمرين"
        )}
        path="/property-development-saudi-arabia"
        image={developmentPageImages[0]}
        structuredData={buildServiceStructuredData({
          name: "Property Development | QTECH",
          nameAr: "Ã˜ÂªÃ˜Â·Ã™Ë†Ã™Å Ã˜Â± Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã™Å  Ã™ÂÃ™Å  Ã˜Â§Ã™â€žÃ˜Â®Ã˜Â¨Ã˜Â± | Ã˜Â´Ã˜Â±Ã™Æ’Ã˜Â© Ã˜ÂªÃ™â€šÃ™â€ Ã™Å Ã˜Â§Ã˜Âª Ã˜Â§Ã™â€žÃ˜Â¬Ã™Ë†Ã˜Â¯Ã˜Â©",
          description:
            "QTECH provides property development services in Saudi Arabia, from feasibility review and concept development to consultant coordination, execution oversight, approvals, and handover.",
          descriptionAr:
            "Ã˜ÂªÃ™â€šÃ˜Â¯Ã™â€¦ Ã˜Â´Ã˜Â±Ã™Æ’Ã˜Â© Ã˜ÂªÃ™â€šÃ™â€ Ã™Å Ã˜Â§Ã˜Âª Ã˜Â§Ã™â€žÃ˜Â¬Ã™Ë†Ã˜Â¯Ã˜Â© Ã˜Â®Ã˜Â¯Ã™â€¦Ã˜Â§Ã˜Âª Ã˜ÂªÃ˜Â·Ã™Ë†Ã™Å Ã˜Â± Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã™Å  Ã™ÂÃ™Å  Ã˜Â§Ã™â€žÃ˜Â®Ã˜Â¨Ã˜Â± Ã™Ë†Ã˜Â§Ã™â€žÃ˜Â³Ã˜Â¹Ã™Ë†Ã˜Â¯Ã™Å Ã˜Â© Ã˜ÂªÃ˜Â´Ã™â€¦Ã™â€ž Ã˜ÂªÃ˜Â·Ã™Ë†Ã™Å Ã˜Â± Ã˜Â§Ã™â€žÃ™â€¦Ã˜Â´Ã˜Â§Ã˜Â±Ã™Å Ã˜Â¹ Ã˜Â§Ã™â€žÃ˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã™Å Ã˜Â©Ã˜Å’ Ã˜Â¥Ã˜Â¯Ã˜Â§Ã˜Â±Ã˜Â© Ã™â€¦Ã˜Â´Ã˜Â§Ã˜Â±Ã™Å Ã˜Â¹ Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã™Å Ã˜Â©Ã˜Å’ Ã˜Â§Ã™â€žÃ˜ÂªÃ™â€ Ã˜Â³Ã™Å Ã™â€š Ã™â€¦Ã˜Â¹ Ã˜Â§Ã™â€žÃ™â€¦Ã™â€šÃ˜Â§Ã™Ë†Ã™â€žÃ™Å Ã™â€ Ã˜Å’ Ã™Ë†Ã™â€¦Ã˜ÂªÃ˜Â§Ã˜Â¨Ã˜Â¹Ã˜Â© Ã˜Â§Ã™â€žÃ˜ÂªÃ™â€ Ã™ÂÃ™Å Ã˜Â°.",
          path: "/property-development-saudi-arabia",
          image: developmentPageImages[0],
          serviceType: "Property Development",
        })}
      />

      <PageTitle
        title={copy.title}
        currentPage={copy.title}
        bgImage="/img/bg/14.jpg"
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <div className="ltn__blog-img">
                  <img
                    src={developmentPageImages[0]}
                    alt={copy.imageLabel}
                    style={{ width: "100%", minHeight: "460px", objectFit: "cover" }}
                  />
                </div>

                <h2 className="title-2">{copy.imageLabel}</h2>

                {copy.paragraphs.map((text, index) => (
                  <LocalizedLeadParagraph
                    key={index}
                    text={text}
                    index={index}
                    locale={locale}
                  />
                ))}

                {Array.isArray(copy.highlights) && copy.highlights.length > 0 ? (
                  <div className="qtech-service-highlight-list">
                    {copy.highlights.map((item, index) => (
                      <div className="qtech-service-highlight-card" key={item.title || index}>
                        <h5>{item.title}</h5>
                        <p>{item.body}</p>
                      </div>
                    ))}
                  </div>
                ) : null}

                <div
                  style={{
                    marginTop: "34px",
                    marginBottom: "18px",
                    padding: "0 2px",
                  }}
                >
                  <h4
                    className="title-2"
                    style={{
                      marginBottom: "10px",
                    }}
                  >
                    {developmentGalleryTitle}
                  </h4>
                  <p
                    style={{
                      marginBottom: "0",
                      color: "#5c727d",
                      lineHeight: "1.8",
                    }}
                  >
                    {developmentGalleryText}
                  </p>
                </div>

                <div className="row g-4 mb-4">
                  {developmentPageImages.slice(1).map((image, index) => {
                    const imageCaptions = [galleryCaptionOne, galleryCaptionTwo];

                    return (
                      <div className="col-md-6" key={image}>
                        <div style={imageCardStyle}>
                          <img
                            src={image}
                            alt={`${copy.imageLabel} ${index + 2}`}
                            style={{
                              width: "100%",
                              height: "290px",
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                          <div
                            style={{
                              padding: "16px 18px 18px",
                              background: "#fffdfa",
                              borderTop: "1px solid rgba(187, 165, 92, 0.12)",
                            }}
                          >
                            <div
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                fontWeight: "700",
                                letterSpacing: "0.05em",
                                textTransform: "uppercase",
                                color: "#bba55c",
                                marginBottom: "6px",
                              }}
                            >
                              {copy.imageLabel}
                            </div>
                            <p
                              style={{
                                margin: 0,
                                color: "#1f2937",
                                fontWeight: 600,
                                lineHeight: 1.6,
                              }}
                            >
                              {imageCaptions[index] || copy.imageLabel}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <h4 className="title-2 mt-4">{lifecycleHeading}</h4>

                {Array.isArray(copy.serviceMatrix) && copy.serviceMatrix.length > 0 ? (
                  <div className="qtech-service-matrix">
                    <div className="qtech-service-matrix__header">
                      <span>{matrixHeaderPhase}</span>
                      <span>{matrixHeaderDetails}</span>
                    </div>
                    {copy.serviceMatrix.map((row, index) => (
                      <div className="qtech-service-matrix__row" key={row.service || index}>
                        <div className="qtech-service-matrix__service">{row.service}</div>
                        <div className="qtech-service-matrix__details">{row.details}</div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    {sidebar.map((item) => (
                      <li
                        key={item.to}
                        className={item.to === "/property-development-saudi-arabia" ? "active" : ""}
                      >
                        <Link to={item.to}>
                          {item.label}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <ServiceInquiryForm
                  serviceTitle={copy.title}
                  serviceSlug="property-development-saudi-arabia"
                />
                <div className="widget ltn__banner-widget">
                  <a href="/shop.html">
                    <img
                      src={developmentSidebarImage}
                      alt={copy.imageLabel}
                      style={{ width: "100%", minHeight: "320px", objectFit: "cover" }}
                    />
                  </a>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyDevelopmentServiceDetails;
